import { useRef, useState } from "react"
import styles from "./flowerfieldRegister.module.css"
import FileBase64 from "react-file-base64"
import Close from "@/common/icons/close"
import File from "@/common/icons/file"

export default function Upload({
  onDone = false,
  onChange,
  maxUploaded = 5,
  uploadedImages = [],
  onRemove,
  allowedFileTypes = false,
  tooltipText = "Tillåta filformat: jpg/jpeg, png och webp.<br />Max 5 bilder.<br />Max storlek: 20mb",
  allowedFileTypesError = "Filen måste vara i följande format: jpg/jpeg, png eller webp"
}) {
  const [uploadErrors, setUploadErrors] = useState(false)
  const wrapperRef = useRef()

  if (!allowedFileTypes) {
    allowedFileTypes = ["image/png", "image/jpeg", "image/jpg", "image/webp"]
  }

  const resetFiles = () => {
    if (!wrapperRef.current) {
      return
    }

    const input = wrapperRef.current.querySelector("input")
    if (input) {
      input.value = ""
    }
  }

  const addFiles = (files) => {
    setUploadErrors(false)

    // Check for number of files
    files.forEach((file) => {
      if (parseInt(file.size) > 20480) {
        setUploadErrors("Bilden måste vara mindre än 20 Mb, försök igen")
        return
      }

      if (allowedFileTypes.includes(file.type)) {
        onChange(file)
      } else {
        setUploadErrors(allowedFileTypesError)
        return
      }
    })
    if (onDone) {
      onDone()
    }
  }

  function removeFile(index) {
    onRemove(index)
  }

  return <>
    <div className="flex flex-col w-full mb-10" ref={wrapperRef}>
      <label className={styles.label}>
        Ladda upp bild
        <Tooltip>
          <div dangerouslySetInnerHTML={{ __html: tooltipText }} />
        </Tooltip>
      </label>
      {uploadedImages.length > maxUploaded && (
        <div
          className={
            styles.fileholder +
            " flex items-center justify-center flex-1 w-full mb-5 bg-green-5 py-14"
          }>
          Du kan max ladda upp {maxUploaded} filer
        </div>
      )}

      {uploadedImages.length <= maxUploaded && (
        <label
          onClick={resetFiles}
          className={
            styles.fileholder +
            " flex flex-col items-center justify-center flex-1 w-full mb-5 bg-green-5 py-14 border border-dashed border-black-100/20 hover:border-black-100/75 cursor-pointer"
          }>
          <div>Klicka för att ladda upp</div>
          {uploadErrors && (
            <div className="text-red-100 upload-errors">{uploadErrors}</div>
          )}
          <FileBase64 multiple={true} onDone={addFiles.bind(this)} />
        </label>
      )}

      <label className={styles.label}>Uppladdade bilder</label>
      <div className="flex flex-wrap justify-between w-full">
        {uploadedImages.map((element, index) => {
          const reg = new RegExp(/data:(.*);base64/gi)
          const type = element?.type ?? reg.exec(element.base64)[1]

          return (
            <div key={index} className="relative flex w-full mb-4">
              {[
                "image/png",
                "image/jpg",
                "image/jpeg",
                "image/webp"
              ].includes(type) ? (
                <>
                  {element.temp && (
                    <img src={element.temp} className="h-auto w-30 md:w-50" />
                  )}

                  {!element.temp && element.base64 && (
                    <img
                      src={element.base64}
                      className="h-auto w-30 md:w-50"
                    />
                  )}
                </>
              ) : (
                <div className="flex-grow-0 flex-shrink-0 w-30 md:w-50">
                  <figure className="relative flex items-center justify-center bg-summer-green-25 aspect-w-4 aspect-h-3">
                    <File className="absolute w-10 h-10 -translate-x-1/2 -translate-y-1/2 fill-current top-1/2 left-1/2" />
                  </figure>
                </div>
              )}
              <div className="flex items-center pl-4 pr-8 text-sm break-all">
                {element.name}
                <br />
                {element.size}
              </div>

              <div
                className="absolute flex items-center justify-center w-10 h-10 cursor-pointer right-3 top-3"
                onClick={() => {
                  removeFile(index)
                  resetFiles()
                }}>
                <div className="flex items-center justify-center w-6 h-6 text-white rounded-full bg-black-100">
                  <Close className="w-2.5 h-2.5 fill-current" />
                </div>
              </div>
            </div>
          )
        })}
        {uploadedImages.length === 0 && <p>Inga bilder valda</p>}
      </div>
    </div>
  </>;
}

const Tooltip = function (props) {
  return (
    <div className={styles.tooltip}>
      <div className={styles.info}>i</div>
      <span className={styles.tooltiptext}>{props.children}</span>
    </div>
  )
}
